import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";

import { ConectorProvider } from "../../providers/conector/conector";
import { GlobalProvider } from "../../providers/global/global";

import { SolicitudPage } from "../../pages/solicitud/solicitud";
import { SolicitudnuevaPage } from "../../pages/solicitudnueva/solicitudnueva";

@Component({
  selector: "page-solicitudes",
  templateUrl: "solicitudes.html"
})
export class SolicitudesPage {
  data: any = {};

  items: any;
  estadossolicitud: any;
  tipossolicitud: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public global: GlobalProvider,
    public conector: ConectorProvider
  ) {
    this.data = {
      background: "assets/images/background/39.jpg"
    };

    this.estadossolicitud = this.global.CONFIGURA["estados_solicitud"];
    this.tipossolicitud = this.global.CONFIGURA["tipos_solicitud"];

    this.conector.getSolicitudes().subscribe(data => {
      let solicitudes = data["solicitudes"];
      solicitudes.forEach(soli => {
        soli.tiponombre = this.tipossolicitud[soli.tipo];
        soli.estadonombre = this.estadossolicitud[soli.estado];
      });
      this.items = solicitudes;

      console.log("solicitudes", this.items);
    });
  }

  nuevasolicitud() {
    console.log("click nuevasolicitud");

    // That's right, we're pushing to ourselves!
    this.navCtrl.push(SolicitudnuevaPage, {});
  }

  iraSolicitud(item) {
    this.navCtrl.push(SolicitudPage, { solicitud: item });
  }

  ionViewDidEnter() {
    console.log("ionViewDidEnter solicitudes");
    this.conector.getSolicitudes().subscribe(async data => {
      let solicitudes = await data["solicitudes"];
      solicitudes.forEach(soli => {
        soli.tiponombre = this.tipossolicitud[soli.tipo];
        soli.estadonombre = this.estadossolicitud[soli.estado];
      });
      this.items = solicitudes;

      console.log("solicitudes", this.items);
    });
  }
  ionViewDidLoad() {
    console.log("ionViewDidLoad SolicitudesPage");
  }
}



// WEBPACK FOOTER //
// ./src/pages/solicitudes/solicitudes.ts